import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
// hooks
import useResponsive from 'src/hooks/useResponsive';
// components
import Logo from 'src/components/logo';
import { NavSectionVertical } from 'src/components/nav-section-new';
import Scrollbar from 'src/components/scrollbar';
import { usePathname } from 'src/routes/hooks';
//
import { useAuthContext } from 'src/auth/hooks/';
import { NavToggleButton } from '../../_common';
import { NAV } from '../../config-layout';
import { NavSuperAdminConfig, NavSiteAdminConfig, NavOrgAdminConfig, NavIndividualUserConfig, NavOrgUserConfig } from './config-navigation';
import { ConfigNavigation } from './config-navigation';
import NavAccount from './NavAccount';
import { ROLES } from 'src/utils/constants/constants';
import { dispatch } from 'src/redux/store';
import { fetchUserById } from 'src/redux/slices/user';
import { routePrefix } from 'src/utils/methods/StandardMethods';
// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const { user } = useAuthContext();
  const [currentUser, setCurrentUser] = useState<any>();
  useEffect(() => {
    const orgCode = routePrefix(user);
    dispatch(fetchUserById(user?.id, orgCode))
      .then((res) => { setCurrentUser(res.user) })
      .catch((err) => console.log(err));
  }, []);

  const renderSwitch = (role: string | undefined) => {
    switch (role) {
      case ROLES.SUPER_ADMIN:
        return NavSuperAdminConfig(user);
      case ROLES.SITE_ADMIN:
        return NavSiteAdminConfig(user);
      case ROLES.ORG_ADMIN:
        return NavOrgAdminConfig(user);
      case ROLES.ORG_USER:
        return NavOrgUserConfig(user);
      case ROLES.INDIVIDUAL_USER:
        return NavIndividualUserConfig(user);
      default:
        return NavSuperAdminConfig(user);
    }
  }


  console.log('I am here');

  const pathname = usePathname();

  const lgUp = useResponsive('up', 'lg');


  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >

      <Logo sx={{  maxWidth: '7rem' }} />
      {/* <Box sx={{ mt: 8, ml: 4, mb: 1 }} /> */}
      <NavSectionVertical data={renderSwitch(user?.role?.name)} config={{ currentRole: user?.role?.name || 'Super Admin' }} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar >
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: `${NAV.W_VERTICAL}rem` },
      }}
    >
      <NavToggleButton />

      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: 'fixed',
            width: `${NAV.W_VERTICAL}rem`,
            borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        >
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: `${NAV.W_VERTICAL}rem`,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}


// import React, { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// // @mui
// import { Box, Stack, Drawer } from '@mui/material';
// // hooks
// import useResponsive from '../../../hooks/useResponsive';
// // config
// import { NAV } from '../../../config-global';
// // components
// import Logo from '../../../components/logo';
// import Scrollbar from '../../../components/scrollbar';
// import { NavSectionVertical } from '../../../components/nav-section';
// //
// import { navAdminConfig, navUserConfig } from './config-navigation';
// import NavDocs from './NavDocs';
// import NavAccount from './NavAccount';
// import NavToggleButton from './NavToggleButton';
// import { useAuthContext } from '../../../auth/hooks';

// // ----------------------------------------------------------------------

// type Props = {
//   openNav: boolean;
//   onCloseNav: VoidFunction;
// };

// export default function NavVertical({ openNav, onCloseNav }: Props) {
//   const { pathname } = useLocation();

//   const isDesktop = useResponsive('up', 'lg');

//   const { user } = useAuthContext();

//   useEffect(() => {
//     if (openNav) {
//       onCloseNav();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [pathname]);

//   const renderContent = (
//     <Scrollbar
//       sx={{
//         height: 1,
//         '& .simplebar-content': {
//           height: 1,
//           display: 'flex',
//           flexDirection: 'column',
//         },
//       }}
//     >
//       {!isDesktop && <Stack
//         spacing={3}
//         sx={{
//           pt: 3,
//           pb: 2,
//           px: 2.5,
//           flexShrink: 0,
//         }}
//       >
//         {/* <Logo /> */}

//         <NavAccount />
//       </Stack>}

//       {user?.role?.name === 'Admin' ? <NavSectionVertical data={navAdminConfig} /> : <NavSectionVertical data={navUserConfig} />}

//       <Box sx={{ flexGrow: 1 }} />

//       {/* <NavDocs /> */}
//     </Scrollbar>
//   );

//   return (
//     <Box
//       component="nav"
//       sx={{
//         flexShrink: { lg: 0 },
//         width: { lg: NAV.W_DASHBOARD },
//       }}
//     >
//       <NavToggleButton />

//       {isDesktop ? (
//         <Drawer
//           open
//           variant="permanent"
//           PaperProps={{
//             sx: {
//               top: 60,
//               zIndex: 0,
//               width: NAV.W_DASHBOARD,
//               bgcolor: 'transparent',
//               borderRightStyle: 'dashed',
//             },
//           }}
//         >
//           {renderContent}
//         </Drawer>
//       ) : (
//         <Drawer
//           open={openNav}
//           onClose={onCloseNav}
//           ModalProps={{
//             keepMounted: true,
//           }}
//           PaperProps={{
//             sx: {
//               width: NAV.W_DASHBOARD,
//             },
//           }}
//         >
//           {renderContent}
//         </Drawer>
//       )}
//     </Box>
//   );
// }
